import Yup from 'utils/validation';

export const editJobCampaignDetailsSchema = Yup.object({
  jobTitle: Yup.string().required('Enter a job title.'),
  employerName: Yup.string().required('Enter an employer name.'),
  location: Yup.string().required('Enter the location of the job.'),
  contractType: Yup.string().required('Enter contract information.'),
  jobDescriptionText: Yup.string().required('Enter a job description.'),
  additionalContext: Yup.string().nullable()
});

export type EditJobCampaignDetails = Yup.InferType<
  typeof editJobCampaignDetailsSchema
>;
